import React, { useEffect, useState } from "react";
import moment from "moment";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiEdit3, FiEye } from "react-icons/fi";

import { Link } from "react-router-dom";
import { myOHSE } from "app/_services/ehs/ehsEventScheduleServices";

import BackBtn from "app/Components/CommanComponents/BackBtn";

import { ProgressBar } from "react-bootstrap";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { getOhseStatusClass, MEETING_STATUS, MEETING_STATUS_VIEW } from "./CONSTANT";
import { SetPermission } from "app/Components/SetPermission/Permissions";
import { FaInfo } from "react-icons/fa";
import { DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import { ACTIVE_MODULE } from "app/_constants/constant";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const ViewOHSE = ({
  user,
  match: {
    params: { siteId },
  },
}) => {
  //   const filterStatus = useSelector((state) => state.filterReducerTraining);
  //   const [searchFilter, setSearchFilter] = useState();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  //   const onSearchFilter = (props) => {
  //     let value = props?.searchProps?.searchText;
  //     if (searchFilter?.search !== props?.searchProps?.searchText) setSearchFilter(value);
  //   };

  useEffect(() => {
    // myOHSE().then((response) => {
    //   if (!response?.data) return;

    //   response.data = response.data.map((d) => {
    //     const data =
    //       d?.isExecuted == true
    //         ? d?.progressCompleteTask !== 0 && d?.progressTotalTask !== 0
    //           ? (Number(d?.progressCompleteTask / d?.progressTotalTask) * 100).toFixed(2)
    //           : "N/A"
    //         : "N/A";
    //     return { ...d, progressStatus: data };
    //   });
    //   setTableData(response?.data);
    // });

    const fetchData = async () => {
      try {
        const response = await myOHSE();

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }

        response.data = response.data.map((d) => {
          const data =
            d?.isExecuted == true
              ? d?.progressCompleteTask !== 0 && d?.progressTotalTask !== 0
                ? (Number(d?.progressCompleteTask / d?.progressTotalTask) * 100).toFixed(
                    2
                  )
                : "N/A"
              : "N/A";
          return { ...d, progressStatus: data };
        });
        setTableData(response?.data);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "scheduleId",
      text: "OHSE Review ID",
      sort: true,
      formatter: (scheduleId, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        >
          <Link
            className="icons text-cyanBlue"
            to={
              (row?.eventStatus === MEETING_STATUS.draft ||
              row?.eventStatus === MEETING_STATUS.planned
                ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
              row?.id
            }
          >
            {scheduleId}
          </Link>
        </OverlayTrigger>
      ),
    },
    {
      dataField: "type",
      text: "Review Type",
      sort: true,
    },
    {
      dataField: "siteName",
      text: "Location",
      sort: true,
      //   formatter: (site) => `${site?.name}`,
    },
    {
      dataField: "venue",
      text: "Venue",
      sort: true,
    },
    {
      dataField: "date",
      text: "Review Date & Time",
      sort: true,
      formatter: (date) => DDMMYYYYHHMMAFormat(date),
    },
    {
      dataField: "progressStatus",
      text: "Progress",
      sort: true,
      formatter: (row, data) => {
        return (
          <>
            {data?.isExecuted == true ? (
              data?.progressCompleteTask !== 0 && data?.progressTotalTask !== 0 ? (
                <ProgressBar
                  className="progress mb-3 mt-2"
                  now={Number(data?.progressCompleteTask / data?.progressTotalTask) * 100}
                  striped
                  animated
                  label={`${
                    Number(data?.progressCompleteTask / data?.progressTotalTask) * 100
                  }%`}
                  variant="primary"
                ></ProgressBar>
              ) : (
                "N/A"
              )
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      dataField: "eventStatusView",
      text: "Status",
      formatter: (status, row) => {
        return <div className={getOhseStatusClass(row?.eventStatus)}>{status}</div>;
      },
    },
    {
      dataField: "createdAt",
      text: "Time Stamp",
      sort: true,
      formatter: (createdAt, row) => {
        return DDMMYYYYHHMMAFormat(createdAt);
      },
    },

    {
      dataField: "id",
      text: "Action",
      formatter: (id, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Views</Tooltip>}
            >
              <Link
                to={
                  (row?.eventStatus === MEETING_STATUS.draft ||
                  row?.eventStatus === MEETING_STATUS.planned
                    ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                    : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
                  id
                }
                className="icons text-cyanBlue"
              >
                <FiEye />
              </Link>
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          { name: "My OHSE Review" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />
      <div className="card p-4 mb-4 mt-4 EHS_module_create_form">
        <div className="simple-card-title">
          <h3 class="text-capitalize mb-0">MY OHSE Review</h3>

          <BackBtn url={`/health-safety-and-environment/audits-meetings`} />
        </div>

        {!loading ? (
          <SearchBootstrapTable
            tableToolbarView={() => {
              return (
                <Link
                  className="btn-icon"
                  to={"/health-safety-and-environment/audits-meetings/calendar?type=1"}
                >
                  <FaInfo />
                </Link>
              );
            }}
            searchKey={"myOHSEReviewDesktopSearch"}
            data={tableData}
            columns={sortableColumn}
            tableKey="myOHSEReview"
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </>
  );
};

export default ViewOHSE;
